import React from "react";
import { useTranslation } from "react-i18next";
import { formatCPF } from "../../../shared/validation.js";
import { localizedInputValidationProps } from "../lib/localizedValidation.js";

/**
 * CPF field with live mask: 000.000.000-00
 * Parent receives the formatted string; validation strips non-digits.
 */
export function CpfInput({
  value,
  onChange,
  className = "input-clean",
  placeholder,
  required,
  id,
  autoComplete = "off",
}: {
  value: string;
  onChange: (formatted: string) => void;
  className?: string;
  placeholder?: string;
  required?: boolean;
  id?: string;
  autoComplete?: string;
}) {
  const { t } = useTranslation();
  return (
    <input
      id={id}
      className={className}
      type="text"
      inputMode="numeric"
      autoComplete={autoComplete}
      required={required}
      {...(required ? localizedInputValidationProps(t) : {})}
      placeholder={placeholder}
      value={formatCPF(value)}
      onChange={(e) => onChange(formatCPF(e.target.value))}
    />
  );
}
